export enum StatusFilter {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR"
}
